export default __webpack_public_path__ + "static/media/logo.9c367a47.svg";